export default "__VITE_ASSET__kbQPAr7Z__"